module.exports = __webpack_public_path__ + "static/media/nuparla em1 .1 w.96e4d49d.jpg";